import useGetCrypto from '@/hooks/useGetCrypto';
import { Box, Button, Stack, SvgIcon, useTheme } from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import find from 'lodash/find';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { FC, useMemo, useState } from 'react';
import useLiveCrypto from '@/hooks/useLiveCrypto';
import getLocalFile from '@/utils/getLocalFile';
import SeeMore from '@/components/CustomSeeMore';
import dynamic from 'next/dynamic';
import numberUtils from '@/utils/numberUtils';
import { useGetMarketInfoQuery } from '@/services/api';

const source = 'otc';
type TopSectionProps = {
  isPricePage: boolean;
};
const Calculator = dynamic(() => import('@/components/Calculator'));

const TopSection = ({ isPricePage }: TopSectionProps) => {
  const { matches } = useResponsive();
  const theme = useTheme();
  console.log('top section');
  const [, setActiveTab] = useState(1);

  const handleTabClick = (tabIndex: any) => {
    setActiveTab(tabIndex);
    const element = document.getElementById(`section-${tabIndex}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  let {
    query: { symbol }
  } = useRouter();

  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');
  console.log(data);
  symbol = data?.Information?.symbol || symbol;
  const symbolFilter = [
    `${(symbol || '')?.toString().toUpperCase().replace('_PRICE', '')}USDT`,
    `${(symbol || '')?.toString().toUpperCase().replace('_PRICE', '')}TMN`
  ];

  // const source: 'otc' | 'p2p' = data?.Information?.source || 'otc';
  // const itemSourceKey = source === 'otc' ? 'midPrice' : 'price';
  // const symbolFilter = [
  //   `${(symbol || '')?.toString().toUpperCase()}USDT`,
  //   `${(symbol || '')?.toString().toUpperCase()}TMN`
  // ];

  const { result } = useGetCrypto(
    {
      get: {
        side: source,
        filter: symbolFilter
      }
    },
    'getCurrentList',
    symbolFilter
  );
  console.log(result);
  const priceSymbol = (symbol || '')
    ?.toString()
    .toUpperCase()
    .replace('_PRICE', '');

  const { data: marketData } = useGetMarketInfoQuery({
    base: priceSymbol,
    quote: 'usdt'
  });
  const info = marketData?.data?.[0];

  const TMN = find(result || [], item => item.quote === 'TMN');
  const USDT = find(result || [], item => item.quote === 'USDT');

  const handleChipColor = (change: number) => {
    if (change < 0)
      return {
        backgroundColor: 'error' as const,
        color: theme.palette.error.A100
      };
    if (change > 0)
      return {
        bacgroundColor: 'success' as const,
        color: theme.palette.success.A100
      };
    return {
      color: 'secondary' as const
    };
  };

  const calculateChangePrice = (change?: number) => {
    if (change) return `${change}%`;
    return '0%';
  };

  const currentAsset = result?.[0] || {};

  const { message, isConnected } = useLiveCrypto({
    source,
    symbol: currentAsset.symbol || '',
    connect: !!currentAsset,
    pingPong: false
  });
  const { message: USDTMessage, isConnected: isConnectedUSDT } = useLiveCrypto({
    source,
    symbol: USDT?.symbol || '',
    connect: !!USDT,
    pingPong: false
  });
  console.log('usdtmessage:', USDTMessage, isConnectedUSDT);
  const { message: TMNMessage, isConnected: isConnectedTMN } = useLiveCrypto({
    source,
    symbol: TMN?.symbol || '',
    connect: !!TMN,
    pingPong: false
  });
  console.log('tmnmessage:', TMNMessage, isConnectedTMN);

  const changePrice =
    isConnected && !!message?.priceChange
      ? Number(message.priceChange)
      : Number(currentAsset?.[source]?.priceChange || 0);

  const isUSDT = symbol === 'USDT';

  const dynamicData = {
    cryptoName: data?.Information.name_fa,
    cryptoPriceTMN:
      isConnectedTMN && !!TMNMessage?.midPrice
        ? TMNMessage.midPrice
        : TMN?.[source]?.midPrice || '-',
    cryptoPriceTTR: isUSDT
      ? '1'
      : isConnectedUSDT && !!USDTMessage?.midPrice
      ? USDTMessage.midPrice
      : USDT?.otc?.midPrice || '-',
    changePercent: calculateChangePrice(changePrice),
    marketCap: isUSDT ? '1' : info ? numberUtils.delimiter(info.marketcap) : '-'
  };

  const replacePlaceholders = (text: string, data: any) => {
    return text
      .toString()
      .replace(/{(.*?)}/g, (_, key) => data[key] || `{${key}}`);
  };

  const description = replacePlaceholders(
    data?.HeroSection.description,
    dynamicData
  );

  const logoAddress = useMemo(() => {
    const address = 'https://p.rabex.ir/api/v1/wallet/static/img';
    return `${address}/${data?.Information?.symbol}.svg`;
  }, [data]);

  return (
    <>
      {matches({
        xs: (
          <Stack flexDirection="column" alignItems="center" gap={1.5}>
            <Stack alignItems="center">
              <Stack gap={6} alignItems="center">
                <Stack gap={0} alignItems="center" flexGrow={1} mt={3.25}>
                  <Stack>
                    <Image src={logoAddress} width={64} height={64} alt="" />
                  </Stack>
                  <Stack alignItems="center">
                    <Typography
                      component="h1"
                      variant={matches({ xs: 'subtitle', lg: 'h5' })}
                      weight="bold"
                      color="#222531"
                    >
                      {`${isPricePage ? 'قیمت' : 'خرید'} ${
                        data.HeroSection.asset
                      }`}
                    </Typography>
                    <Typography
                      variant={matches({ xs: 'body3', lg: 'body2' })}
                      component="p"
                      color="#000000"
                    >
                      {data.HeroSection.symbol}
                    </Typography>
                    <Stack flexDirection="row" gap={1}>
                      <Typography variant="body2" weight="normal">
                        {`${data.HeroSection.changeInLastDay}:`}
                      </Typography>
                      <Typography
                        variant="body2"
                        weight="normal"
                        component="p"
                        sx={{ ...handleChipColor(changePrice) }}
                      >
                        {calculateChangePrice(changePrice)}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack
                  flexDirection="row"
                  alignItems="center"
                  gap={2.08}
                  flexGrow={1}
                  sx={{ width: '100%' }}
                >
                  <Stack
                    flexGrow={1}
                    justifyContent="center"
                    alignItems="center"
                    width={{ xs: 160.67 }}
                    sx={{
                      paddingX: 3,
                      paddingY: 1.5,
                      backgroundColor: theme.palette.secondary.main,
                      height: 76,
                      borderRadius: 0
                    }}
                    gap={1.5}
                  >
                    <Typography variant="body3" weight="normal" component="h2">
                      {data.HeroSection.buyWithFiat}
                    </Typography>
                    <Stack flexDirection="row" gap={1} alignItems="baseline">
                      <Typography
                        variant="body2"
                        weight="bold"
                        color="#222531"
                        component="p"
                      >
                        {isConnectedTMN && !!TMNMessage?.midPrice
                          ? TMNMessage.midPrice
                          : TMN?.[source]?.midPrice || '-'}
                      </Typography>
                      <Typography variant="body3" color="#222531">
                        تومان
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    flexGrow={1}
                    justifyContent="center"
                    alignItems="center"
                    width={{ xs: 160.67 }}
                    sx={{
                      paddingX: 3,
                      paddingY: 1.5,
                      backgroundColor: theme.palette.secondary.main,
                      height: 76,
                      borderRadius: 0
                    }}
                    gap={1.5}
                  >
                    <Typography variant="body3" weight="normal" component="h2">
                      {data.HeroSection.buyWithUSDT}
                    </Typography>
                    <Stack
                      flexDirection="row-reverse"
                      gap={1}
                      alignItems="baseline"
                    >
                      <Typography
                        variant="body2"
                        weight="bold"
                        color="#222531"
                        component="p"
                      >
                        {isUSDT
                          ? '1'
                          : isConnectedUSDT && !!USDTMessage?.midPrice
                          ? USDTMessage.midPrice
                          : USDT?.otc?.midPrice || '-'}
                      </Typography>
                      <Typography variant="body3" color="#222531">
                        USDT
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack flexGrow={1}>
                  <SeeMore
                    height="30%"
                    minHeight="100px"
                    linearGradient="rgba(255, 255, 255, 0.00)"
                    buttonProps={{
                      variant: 'contained',
                      fullWidth: false
                    }}
                    fadeColor="#F8F8F8"
                    buttonColor="#FFFFFF"
                    buttonHoverColor="#E4E7EB"
                  >
                    <Typography
                      sx={{ fontSize: '12px', lineHeight: '24px' }}
                      color="textColor.A80"
                    >
                      {description}
                    </Typography>
                  </SeeMore>
                </Stack>
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ width: matches({ xs: '90%' }), marginTop: 0 }}
                  onClick={() =>
                    window.open('https://p.rabex.ir/auth/login', '_blank')
                  }
                >
                  <Typography variant={matches({ xs: 'body2' })} weight="bold">
                    معامله
                  </Typography>
                </Button>
              </Stack>
              <Stack>
                <Calculator
                  toTmnPrice={
                    isConnectedTMN && !!TMNMessage?.midPrice
                      ? TMNMessage.midPrice
                      : TMN?.[source]?.midPrice || 1
                  }
                  toUSDTPrice={
                    isUSDT
                      ? 1
                      : isConnectedUSDT && !!USDTMessage?.midPrice
                      ? USDTMessage.midPrice
                      : USDT?.otc?.midPrice || 1
                  }
                  title={data.HeroSection.calculatorTitle}
                />
              </Stack>
            </Stack>
          </Stack>
        ),
        lg: (
          <Stack
            flexDirection="row"
            alignItems="center"
            width={1190}
            justifyContent="space-between"
          >
            <Stack gap={6} alignItems="start">
              <Stack
                gap={4}
                flexDirection="row"
                alignItems="center"
                mt={{ xs: 0, lg: 7.75 }}
                flexGrow={1}
              >
                <Stack>
                  <Image src={logoAddress} width={64} height={64} alt="" />
                </Stack>
                <Stack>
                  <Typography
                    component="h1"
                    variant={matches({ xs: 'subtitle', lg: 'h5' })}
                    weight="bold"
                    color="#222531"
                  >
                    {`${isPricePage ? 'قیمت' : 'خرید'} ${
                      data.HeroSection.asset
                    }`}
                  </Typography>
                  <Typography
                    variant={matches({ xs: 'body3', lg: 'body2' })}
                    component="p"
                    color="#000000"
                  >
                    {data.HeroSection.symbol}
                  </Typography>
                </Stack>
              </Stack>
              <Stack width={700} height={142} flexGrow={1}>
                <Typography
                  variant="body2"
                  weight="normal"
                  color="textColor.A80"
                >
                  {description}
                </Typography>
              </Stack>
              <Stack
                flexDirection="row"
                alignItems="center"
                gap={4}
                flexGrow={1}
                sx={{ width: '100%' }}
              >
                <Stack
                  flexGrow={1}
                  justifyContent="center"
                  alignItems="start"
                  sx={{
                    paddingX: 6,
                    paddingY: 15,
                    backgroundColor: theme.palette.secondary.main,
                    height: 124,
                    borderRadius: 2
                  }}
                  gap={1.5}
                >
                  <Typography
                    variant="body2"
                    weight="normal"
                    component="h2"
                    color="#222531"
                  >
                    {data.HeroSection.buyWithFiat}
                  </Typography>
                  <Stack flexDirection="row" gap={1} alignItems="baseline">
                    <Typography
                      variant="body2"
                      weight="normal"
                      color="#222531"
                      component="p"
                    >
                      {isConnectedTMN && !!TMNMessage?.midPrice
                        ? TMNMessage.midPrice
                        : TMN?.[source]?.midPrice || '-'}
                    </Typography>
                    <Typography variant="body3" color="#222531">
                      تومان
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  flexGrow={1}
                  justifyContent="center"
                  alignItems="start"
                  sx={{
                    paddingX: 6,
                    paddingY: 15,
                    backgroundColor: theme.palette.secondary.main,
                    height: 124,
                    borderRadius: 2
                  }}
                  gap={1.5}
                >
                  <Typography
                    variant="body2"
                    weight="normal"
                    component="h2"
                    color="#222531"
                  >
                    {data.HeroSection.buyWithUSDT}
                  </Typography>
                  <Stack
                    flexDirection="row-reverse"
                    gap={1}
                    alignItems="baseline"
                  >
                    <Typography
                      variant="body2"
                      weight="normal"
                      color="#222531"
                      component="p"
                    >
                      {isUSDT
                        ? '1'
                        : isConnectedUSDT && !!USDTMessage?.midPrice
                        ? USDTMessage.midPrice
                        : USDT?.otc?.midPrice || '-'}
                    </Typography>
                    <Typography variant="body3" color="#222531" component="p">
                      USDT
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  flexGrow={1}
                  justifyContent="center"
                  alignItems="start"
                  sx={{
                    paddingX: 6,
                    paddingY: 15,
                    backgroundColor: theme.palette.secondary.main,
                    height: 124,
                    borderRadius: 2
                  }}
                  gap={1.5}
                >
                  <Typography
                    variant="body2"
                    weight="normal"
                    component="p"
                    color="#222531"
                  >
                    {data.HeroSection.changeInLastDay}
                  </Typography>
                  <Stack flexDirection="row" gap={1} alignItems="center">
                    <Typography
                      variant="body2"
                      weight="normal"
                      sx={{ ...handleChipColor(changePrice) }}
                    >
                      {calculateChangePrice(changePrice)}
                    </Typography>
                    {changePrice > 0 ? (
                      <SvgIcon
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.25 11.875L10 8.125L13.75 11.875"
                          stroke="#2EBD85"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </SvgIcon>
                    ) : (
                      <SvgIcon
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.75 8.125L10 11.875L6.25 8.125"
                          stroke="#EA3943"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          fill="none"
                        />
                      </SvgIcon>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Stack>
              <Calculator
                toTmnPrice={
                  isConnectedTMN && !!TMNMessage?.midPrice
                    ? TMNMessage.midPrice
                    : TMN?.[source]?.midPrice || 1
                }
                toUSDTPrice={
                  isUSDT
                    ? 1
                    : isConnectedUSDT && !!USDTMessage?.midPrice
                    ? USDTMessage.midPrice
                    : USDT?.otc?.midPrice || 1
                }
                title={data.HeroSection.calculatorTitle}
              />
            </Stack>
          </Stack>
        )
      })}
    </>
  );
};

export default TopSection;
